<app-stepper-form
  header="Cancellation"
  subheader="Form 484C1"
  [steps]="stepsSignal()"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [isInvalid]="hasShareIssue"
  [form]="stepperForm"
>
  <div class="step-content full-width" [formGroup]="stepperForm">
    <div class="step-content">
      <app-stepper-form-description
        formKey="484C1"
        [hidden]="currentStep !== StepsEnum.FormDescription"
      />
    </div>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.ShareholderAndCancellationDetails"
      [hidden]="currentStep !== StepsEnum.ShareholderAndCancellationDetails"
    >
      <h1 class="h1-heading">Cancellation Details</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Cancellation"
          formControlName="transactionDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [smallWidth]="true"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <app-share-cancellation-block
        [formGroup]="shareholderDetailsForm"
        [securityRegistryRecords]="securityRegistryRecords"
        [companyChangeData]="companyChangeData"
        [parentFormGroup]="stepperForm"
      />

      <div class="form-group certificate-group">
        <app-divider margin="24px 0 32px"/>

        <div class="form-group">
          <app-radio
            label="Consideration Type"
            formControlName="issueForCashConsidarationOnly"
            [options]="considerationTypesOptions"
          />
        </div>

        <div class="form-group"
             [hidden]="shareholderDetailsForm.controls.issueForCashConsidarationOnly.value !== false">
          <app-textarea
            label="Non Cash Consideration Details"
            formControlName="nonCashConsiderationDetails"
          />
        </div>

        <div
          [hidden]="certificatePartHidden"
        >
          <div class="form-group">
            <app-select
              label="Certificate Consolidation"
              formControlName="consolidateCertificate"
              [options]="certificateConsolidationOptions"
              [valuePrimitive]="true"
            />
          </div>

          <div class="form-group">
            <input-certificate-number
              label="Certificate Number"
              formControlName="shareCertificateNumber"
              [entityId]="companyChangeData.entityId"
              [transactionsList]="transactionsList"
            />
          </div>
        </div>
      </div>

      <app-divider margin="24px 0 32px"/>

      <div class="form-group">
        <app-select-groups
          label="Reason for Cancellation"
          formControlName="reason"
          [optionGroups]="reasonForCancellationOptionGroups"
        />
      </div>

      <app-disclaimer
        [hidden]="shareholderDetailsForm.controls.reason.value !== CancellationReason.CapitalReductionMultipleShareholder">
        A Form 2560 must be lodged before a capital reduction takes place.
      </app-disclaimer>

      <app-disclaimer [hidden]="shareholderDetailsForm.controls.reason.value !== CancellationReason.BuyBackOther">
        A Form 280 or 281 must be lodged at least 14 days. and no more than 1 year before the share buy-back can take
        place.
      </app-disclaimer>

      <div [hidden]="shareholderDetailsForm.controls.reason.value !== CancellationReason.Other">
        <div class="form-group">
          <app-textarea label="Description" formControlName="reasonDescription"/>
        </div>

        <div class="form-group">
          <app-input label="Section Reference" formControlName="section"/>
        </div>
      </div>
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.Form280"
      [hidden]="currentStep !== StepsEnum.Form280"
    >
      <h1 class="h1-heading">{{ stepsSignal()[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Relevant Date"
          formControlName="changeDate"
          [minDate]="minDate"
        />
      </div>

      <div class="form-group">
        <app-select
          label="Type of share buy-back"
          formControlName="buyBackType"
          [options]="buyBackTypeOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group">
        <app-select
          label="Documents attached to this form"
          formControlName="attachedDocumentType"
          [options]="buyBackDocumentTypeOptions"
          [valuePrimitive]="true"
        />
      </div>
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.Form2560"
      [hidden]="currentStep !== StepsEnum.Form2560"
    >
      <h1 class="h1-heading">{{ stepsSignal()[currentStepIndex].label }} (Form 2560)</h1>

      <div class="form-group">
        <app-radio
          label="Documents lodged"
          formControlName="section"
          [options]="form2560DocumentsOptions"
          [horizontalAlign]="false"
        />
      </div>

      <div class="form-group">
        <app-date-picker
          label="Date of Proposed Meeting"
          formControlName="dateOfProposedMeeting"
          [minDate]="minDate"
        />
      </div>

      <div class="form-group">
        <app-checkbox
          label="Tick box if ss.249H(2) applies"
          formControlName="section249hAppliesForUnlistedCompany"
        />
      </div>

      <div class="form-group">
        <app-checkbox
          label="Is Listed Company"
          formControlName="isListedCompany"
        />
      </div>
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.AuthorisedSignatories"
      [hidden]="currentStep !== StepsEnum.AuthorisedSignatories"
    >
      <app-authorised-signatories-step
        title="Authorised Signatories"
        [formGroup]="authorisedSignatoriesForm"
        [securityRegistryRecords]="authorisedSecurityRegistryRecords"
      />
    </section>

    <section
      class="step-section w-100"
      [formGroupName]="StepsEnum.Estimate"
      [hidden]="currentStep !== StepsEnum.Estimate"
    >
      <h1 class="h1-heading">{{ stepsSignal()[currentStepIndex].label }}</h1>

      <app-share-estimate-table
        [isEstimateLoading]="isEstimateLoading"
        [estimatedSecurityRegistryRecords]="estimatedSecurityRegistryRecords"
      />
    </section>
  </div>
</app-stepper-form>
